export const pagination = {
  initialPageSize: 5,
  pageSizeOptions: [5, 10, 20, 50],
};
